import styled from 'styled-components'

import { Link } from '@subaio/components'

import { helpers } from 'styles'

export const LogoLink = styled(Link)`
	display: flex;
	align-items: center;
	column-gap: 8px;
	color: ${helpers.color.textContrast};
	font-size: 18px;
	font-family: ${helpers.font.family.header};

	&:hover,
	&:focus,
	&:active {
		color: ${helpers.color.textContrast};
		text-decoration: none;
	}
`
